// extracted by mini-css-extract-plugin
export default {"buttons":"DeletePropertiesGroupModal_buttons__LHU7E","errorMessage":"DeletePropertiesGroupModal_errorMessage__paQNy"};